export default __webpack_public_path__ + "static/media/scanError.c9e53d6b.wav";